import { useEffect, useMemo, useRef } from "react";
import { useSearchParams } from "react-router-dom";

function headerHeight() {
  return document.querySelector(".site-header")?.getBoundingClientRect().height || 130;
}

export default function InnerPage({ banner, tabs, children }) {
  const [params, setParams] = useSearchParams();
  const skipScroll = useRef(false);
  const lockUntil = useRef(0);
  const active = params.get("tab") || tabs[0]?.id;
  const offsets = useMemo(() => tabs.map((t) => t.id), [tabs]);

  useEffect(() => {
    const tab = params.get("tab");
    if (!tab || !offsets.includes(tab)) return;
    if (skipScroll.current) {
      skipScroll.current = false;
      return;
    }
    const el = document.getElementById(tab);
    if (!el) return;
    lockUntil.current = Date.now() + 700;
    const top = el.getBoundingClientRect().top + window.scrollY - headerHeight() - 8;
    window.scrollTo({ top, behavior: "smooth" });
  }, [params, offsets]);

  useEffect(() => {
    if (!tabs.length) return undefined;
    const onScroll = () => {
      if (Date.now() < lockUntil.current) return;
      const y = window.scrollY;
      const offset = headerHeight() + 20;
      const positions = tabs
        .map((t) => {
          const el = document.getElementById(t.id);
          return { id: t.id, top: el ? el.offsetTop : 0 };
        })
        .filter((t) => y + offset >= t.top);
      const next = positions[positions.length - 1]?.id;
      if (next && next !== active) {
        skipScroll.current = true;
        setParams({ tab: next }, { replace: true });
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [tabs, active, setParams]);

  return (
    <div className="inner-page">
      {banner}
      <div className="inner-body">{children}</div>
    </div>
  );
}
